// Angular Imports
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// Shared Imports
import { NotfoundComponent } from '@shared/components'
import { isLoggedGuard, hasRolesGuard } from '@shared/guards'
import { ERoles } from '@shared/models'

const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
	},
	{
		path: '',
		loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: 'dashboard',
		loadChildren: () =>
			import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
		canLoad: [isLoggedGuard],
		canActivate: [isLoggedGuard, hasRolesGuard],
		data: {
			allowedRoles: [ERoles.viewer, ERoles.administrator],
		},
	},
	{
		path: '**',
		component: NotfoundComponent,
		data: {
			returnBack: false,
			redirectTo: 'dashboard',
		},
	},
]

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
